import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getAllStudentChapters({ payload }) {
  try {
    yield put(actions.addStudentChapterLoading(true));
    const result = yield call(api.getAllStudentChapters, payload);
    yield put(actions.getAllStudentChaptersSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getAllStudentChaptersFail());
  } finally {
    yield put(actions.addStudentChapterLoading(false));
  }
}

function* getStudentChapter({ payload }) {
  try {
    yield put(actions.addStudentChapterLoading(true));
    const result = yield call(api.getStudentChapter, payload);
    yield put(actions.getStudentChapterSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getStudentChapterFail());
  } finally {
    yield put(actions.addStudentChapterLoading(false));
  }
}

function* getStudentChapters({ payload }) {
  try {
    yield put(actions.addStudentChapterLoading(true));
    const result = yield call(api.getStudentChapter, payload);
    yield put(actions.getStudentChapterSuccess(result.data));
  } catch (error) {
    const { response, message } = error;
    toast.error(error);
    //console.log(error, 'error');
    yield put(actions.getStudentChapterFail());
  } finally {
    yield put(actions.addStudentChapterLoading(false));
  }
}

export default function* StudentChapter() {
  yield takeLatest(Types.GET_STUDENT_CHAPTERS_REQUEST, getAllStudentChapters);
  yield takeLatest(Types.GET_ALL_STUDENT_CHAPTERS_REQUEST, getStudentChapters);
  yield takeLatest(Types.GET_STUDENT_CHAPTER_REQUEST, getStudentChapter);
}
